import { gql } from '@apollo/client';

export const GET_SYSTEM = gql`
  query getSystem($system_id: String!) { 
    getSystem(system_id: $system_id) {
      system_id,
      basic_info {
        nickname,
        customer_reference,
        connection_state,
        system_uptime(days: 1),
        mobile_network_status {rssi, min_signal_percentage, signal_power, signal_quality, network_type, version},
        battery_state_of_charge {state_of_charge},
        pendant_status {sensor_id, connected, last_heartbeat_utc, zone},
        sim_iccid,
        system_status {
          system_state,
          timestamp_utc
        }
      },
      advanced_info {
        sensor_pairing_events(start_date:"2020-01-01T00:00:00.000Z"){
          items{
            sensor_id,
            timestamp_utc
          }
        }
        organisation_setting{
          pers_provider,
          pers_region,
          village_operator,
          village_name,
          care_provider,
          care_provider_region
        }    
        alert_reports(limit:50)
        {
          items {
            type,
            timestamp_utc,
            callback_wait_time,
            callback_duration,
            endpoint,
            resolution,
            interface
          }
        },
        alerts(limit:50)
        {
          items {
            alert_id,
            cid_code,
            message,
            priority,
            status,
            timestamp_utc,
            type
          }
        },
        installed_versions {
          package,
          version
        }
      },
      configuration {
        pers_id,
        alert_endpoints {
          alert_protocol,
          address
        },
        
        desired {
          pers_id,
          alert_endpoints {
            alert_protocol,
            address
          },
        }
        features {
          personal_alarm,
          smoke_alarm_detection
        }
        firmware_versions {
          service,
          version
        }
      }
    }
  }
`;
